import React, { useState } from "react";
import { Box, Stack, TextField, InputAdornment } from "@mui/material";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";


import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomButton from "../components/CustomButton";
import { auth, googleProvider } from "../services/firebase";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";

const API_URL = process.env.REACT_APP_API_URL

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    if (email === "" || password === "") {
      setErrorMessage("");
      return;
    }
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        navigate("/dashboard");
      })
      .catch((error) => {});
  };

  const handleLoginWithGoogle = (e) => {
    e.preventDefault();
    signInWithPopup(auth, googleProvider)
      .then(async (result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        fetch(`${API_URL}/firebase/save-user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userEmail: result.user.email,
            UID: result.user.uid,
            userName: '',
            payPalHandle: '',
          })
        })
        navigate("/dashboard");
      })
      .catch((error) => {});
  };

  const clearInput = (inputField) => {
    switch (inputField) {
      case "email":
        setEmail("");
        break;
      case "password":
        setPassword("");
        break;
      default:
        break;
    }
  };

  return (
    <Box className="max_container">
      <Stack spacing={2} className="pt-20">
        <TextField
          id="input-with-icon-textfield"
          label="Email"
          placeholder="input"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person2OutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("email")}
                  className="cursor-pointer"
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />

        {/* Password input  */}
        <TextField
          id="input-with-icon-textfield"
          label="Password"
          placeholder="input"
          fullWidth
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("password")}
                  className="cursor-pointer"
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />

        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
      </Stack>
      <Stack spacing={2} className="mt-48 px-12">
        <CustomButton 
          myFunction={handleLogin}
          text={"Login"}
        />
        <CustomButton 
          // myFunction={handleLoginWithGoogle}
          myFunction={() => alert('Login with Google is currently unavailable, contact us to get an account!')}
          text={"Login with Google"}
        />
        <div>
          Don't have an account?
          <Link to="/CreateAccount"> Sign Up</Link>
        </div>
      </Stack>
    </Box>
  );
};

export default Login;